const StemDrumSvg: React.FC<{ color?: string }> = ({ color }) => {
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85325 8.08982L15.2817 13.9192L15.7813 12.9971L5.35282 7.15712L4.85325 8.08982ZM17.6963 12.9971L18.1958 13.9192L28.6243 8.08982L28.1247 7.15712L17.6963 12.9971ZM16.7492 27.1571C10.7856 27.1571 4.74918 25.9171 4.74918 23.5641V13.4316C4.74918 12.2234 6.35195 11.3119 8.71448 10.7077L10.0987 11.4814C7.3719 12.0114 5.78994 12.8063 5.78994 13.4316C5.78994 14.4703 10.0675 15.9648 16.7492 15.9648C23.4309 15.9648 27.7084 14.4915 27.7084 13.4316C27.7084 12.8063 26.1369 12.0114 23.4205 11.4814L24.8047 10.7077C27.1568 11.3119 28.7492 12.2234 28.7492 13.4316V23.5641C28.7492 25.9171 22.7127 27.1571 16.7492 27.1571ZM26.8984 15.4442C24.819 16.4127 21.2551 16.9439 17.6085 17.0161L21.9427 25.2811L26.8984 15.4442ZM15.8462 17.0152C11.7901 16.9309 7.84325 16.2784 5.93586 15.088L11.1083 25.1857L15.8462 17.0152ZM27.7084 16.164L22.9583 25.6027C25.9646 25.0734 27.7084 24.2213 27.7084 23.5641V16.164ZM21.0755 25.8699L16.7285 17.5864L11.9542 25.8195C13.3575 25.9928 14.9674 26.0972 16.7492 26.0972C18.3358 26.0972 19.7861 26.0126 21.0755 25.8699ZM10.1125 25.5326L5.78994 17.098V23.5641C5.78994 24.2089 7.36904 25.0066 10.1125 25.5326ZM16.7492 10.8985C18.0605 10.8985 19.2678 10.9621 20.3814 11.0575L21.9634 10.1778C20.2379 9.94937 18.4996 9.83607 16.7596 9.83862C15.0199 9.83731 13.2819 9.94705 11.5558 10.1672L13.1377 11.0575C14.2409 10.9621 15.4482 10.8985 16.7492 10.8985Z"
        fill={color || "white"}
      />
      {/* <rect
        x="0.624176"
        y="1.03212"
        width="32.25"
        height="32.25"
        stroke="#8B8B8B"
        stroke-width="0.25"
      /> */}
    </svg>
  );
};

export default StemDrumSvg;
